import React from 'react';
import PropTypes from 'prop-types';
import { Badge, Row, Col } from 'react-bootstrap-5';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle, faGripVertical } from '@fortawesome/pro-solid-svg-icons';
import { faPencilAlt, faPlusCircle } from '@fortawesome/pro-solid-svg-icons';

import { listItemPropTypes, reorderableListItem } from 'helpers/react_dnd/reorderable_list';
import badgeClass from '../shared/document_badge';
import { Link } from 'react-router-dom';

export class PageLibraryRow extends React.Component {
  static propTypes = {
    ...listItemPropTypes,
    addDefaultPage: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
    locked: PropTypes.bool.isRequired,
    page: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    }),
    removeLibraryPage: PropTypes.func.isRequired,
  }


  render() {
    const { page, locked } = this.props;
    if (!page) return null;

    const {
      addDefaultPage,
      removeLibraryPage,
      connectDragPreview,
      connectDropTarget,
      connectDragSource,
      isDragging
    } = this.props;
    const style = {
      opacity: isDragging ? 0 : 1,
    };

    return (
      connectDragPreview(
        connectDropTarget(
          <li className="list-group-item" key={page.id} name="page-row">
            <Row className="align-items-center w-100" style={style}>
              <Col xs={5}>
                {!locked && connectDragSource(
                  <div className="d-inline cursor-move">
                    <FontAwesomeIcon className="me-2" icon={faGripVertical} />
                  </div>
                )}
                <span>{page.name}</span>
              </Col>
              <Col xs={4}>
                {page.user_label && (
                  <Badge className={`${badgeClass('user_label')} m-1`}>{page.user_label}</Badge>
                )}
                {page.size && (
                  <Badge bg="muted" className={`${badgeClass('size', page.size)} m-1`}>{page.size}</Badge>
                )}
              </Col>
              <Col className="text-end" xs={3}>
                <Link to={`/pages/${page.id}`}>
                  <FontAwesomeIcon
                    className="text-primary clickable"
                    icon={faPencilAlt}
                  />
                </Link>
                {!locked && (
                  <FontAwesomeIcon
                    className="ms-4 clickable text-danger"
                    icon={faMinusCircle}
                    name="remove-page"
                    onClick={() => removeLibraryPage(page.id, page.template_type)}
                  />
                )}
                {!locked && (
                  <FontAwesomeIcon
                    className="text-success clickable ms-4"
                    icon={faPlusCircle}
                    name="add-page"
                    onClick={() => addDefaultPage(page.id, page.template_type)}
                  />
                )}
              </Col>
            </Row>
          </li>
        )
      )
    );
  }
}

export default reorderableListItem(PageLibraryRow, 'pageLibraryRow', {
  beginDrag(props) {
    return {
      id: props.page.id,
      index: props.index
    };
  }
});
